/**
 * @(#)2020/02/27.
 * 状态组件
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
import { ITextBasePropTypes } from "../IpropType/basePropTypes";
import Status from "./status";

import PropTypes from "prop-types";
Status.propTypes = {
  ...ITextBasePropTypes,
  type: PropTypes.string,
  styleType: PropTypes.oneOf(["tag", "icon", "circle"]),
  text: PropTypes.node,
  solid: PropTypes.bool,
  iconParam: PropTypes.object,
};
Status.defaultProps = {
  children: "",
  styleType: "tag", // tag icon  circle
  styleParam: {
    type: "tag", // 类型 tag icon  circle
    size: "default", // 尺寸
  },
  type: null, // 常规提示info 警告提示warning 成功提示success 错误提示error
  text: null, // 展示文本，可空
  solid: true, // 是否实心 当styleType为icon时生效
  iconParam: {}, // 额外的参数 当icon时生效
};

export default Status;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxText/Status/index.js